const TOTAL_DEV_COST = 'Total Dev Cost Forecast';
const TOTAL_DEV_COST_KEY = 'total_dev_cost';
const DEV_COST_TO_DATE = 'Dev Cost to Date';
const DEV_COST_TO_DATE_KEY = 'dev_cost_to_date';
const NET_PROFIT_RATIO = 'Net Profit Ratio';
const NET_PROFIT_RATIO_KEY = 'net_profit_ratio';
const HC = 'Project HC Actual';
const HC_KEY = 'year_hc';
const SALES_Y1 = 'Sales Y1';
const SALES_Y1_KEY = 'sales_y1';
const SALES_Y3 = 'Sales Y3';
const SALES_Y3_KEY = 'sales_y3';
const COPIES_Y1 = 'Copies Y1';
const COPIES_Y1_KEY = 'copies_y1';
const COPIES_Y3 = 'Copies Y3';
const COPIES_Y3_KEY = 'copies_y3';
const CONCEPT = 'Concept';
const CONCEPT_KEY = 'concept';
const VERTICAL_SLICE = 'End of Pre-Production (Vertical Slice)';
// VERTICAL_SLICE = 'Vertical Slice',
const VERTICAL_SLICE_KEY = 'vertical_slice';
const ALPHA = 'Feature Complete (Alpha)';
// const ALPHA = 'Alpha';
const ALPHA_KEY = 'alpha';
const BETA = 'Content Complete (Beta)';
// const BETA = 'Beta';
const BETA_KEY = 'beta';
const EARLY_ACCESS = 'Early Access';
const EARLY_ACCESS_KEY = 'early_access';
const OFFICIAL_LAUNCH = 'Official Launch';
const OFFICIAL_LAUNCH_KEY = 'official_launch';
const STAFF_MONTH_RATE = 'Staff Month Rate';
const STAFF_MONTH_RATE_KEY = 'staff_month_rate';

const DATE_KEYS = [CONCEPT, VERTICAL_SLICE, ALPHA, BETA, EARLY_ACCESS, OFFICIAL_LAUNCH];

// 接口返回字段前端使用映射表
const RES_FIELDS_MAP: any = {
  [TOTAL_DEV_COST]: {
    key: TOTAL_DEV_COST_KEY,
  },
  [DEV_COST_TO_DATE]: {
    key: DEV_COST_TO_DATE_KEY,
  },
  [NET_PROFIT_RATIO]: {
    key: NET_PROFIT_RATIO_KEY,
    isRange: true, // 用于展示范围值
  },
  [HC]: {
    key: HC_KEY,
  },
  [SALES_Y1]: {
    key: SALES_Y1_KEY,
    isRange: true,
  },
  [SALES_Y3]: {
    key: SALES_Y3_KEY,
    isRange: true,
  },
  [COPIES_Y1]: {
    key: COPIES_Y1_KEY,
    isRange: true,
  },
  [COPIES_Y3]: {
    key: COPIES_Y3_KEY,
    isRange: true,
  },
  [CONCEPT]: {
    key: CONCEPT_KEY,
  },
  [VERTICAL_SLICE]: {
    key: VERTICAL_SLICE_KEY,
  },
  [ALPHA]: {
    key: ALPHA_KEY,
  },
  [BETA]: {
    key: BETA_KEY,
  },
  [EARLY_ACCESS]: {
    key: EARLY_ACCESS_KEY,
  },
  [OFFICIAL_LAUNCH]: {
    key: OFFICIAL_LAUNCH_KEY,
  },
  [STAFF_MONTH_RATE]: {
    key: STAFF_MONTH_RATE_KEY,
  },
};

// 排序传参字段映射表
const SORT_REQ_MAP: any = {
  studio: 'studio_name',
  project: 'game_name',
  [TOTAL_DEV_COST_KEY]: TOTAL_DEV_COST,
  [DEV_COST_TO_DATE_KEY]: DEV_COST_TO_DATE,
  [HC_KEY]: HC,
  [STAFF_MONTH_RATE_KEY]: STAFF_MONTH_RATE,
};

export { RES_FIELDS_MAP, SORT_REQ_MAP, DATE_KEYS };
